import { Tenant } from '../index';
import { parseAccountsQueryParams } from '../../../../application/routing/parse-accounts-query-params';
import { DEFAULT_SUBDOMAIN } from '../constants';

declare const URL_LOGIN: string;

export function getAccountsURL(): string{

    if ( typeof URL_LOGIN == 'undefined' ) throw new Error("URL_LOGIN not setted")
    
    const tenant = new Tenant()
    const baseUrl = `${ URL_LOGIN.replace('[[TENANT]]', tenant.tenant) }`
    const params = location.search.replace('&', '').split('&').map( keyValue => ({ key: keyValue.split('=')[ 0 ], value: keyValue.split('=')[ 1 ] }) )

    return baseUrl + parseAccountsQueryParams( { 
                        pathname: location.pathname, 
                        queryParams: params, 
                        subdomain: tenant.subdomain !== DEFAULT_SUBDOMAIN ? tenant.subdomain : undefined 
                    } )

}